import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';

const PII_KEY_RE = /email|phone|name|card|token|password|ssn|pin/i;
const scrubPII = (obj, seen = new WeakSet()) => {
  if (!obj || typeof obj !== 'object' || seen.has(obj)) return;
  seen.add(obj);
  for (const key of Object.keys(obj)) {
    if (PII_KEY_RE.test(key)) {
      obj[key] = '[Filtered]';
    } else if (obj[key] && typeof obj[key] === 'object') {
      scrubPII(obj[key], seen);
    }
  }
};

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV || 'development',
  sampleRate: 1.0,
  beforeSend(event) {
    scrubPII(event);
    return event;
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div>Something went wrong. Please refresh.</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
